'use client';

import { useSettingsStore } from '@/context/global/stores/settingStore';
import IconRemoveText from '@/context/global/components/Icon/IconRemoveText';
import IconSearch from '@/context/global/components/Icon/IconSearch';
import { useTranslations } from 'next-intl';
import { useRouter, usePathname } from 'next/navigation';

export type THeaderSearch = {
  className?: string;
};
export default function CWHeaderSearch({ className = '' }: THeaderSearch) {
  const t = useTranslations();
  const router = useRouter();
  const pathname = usePathname();
  const searchQuery = useSettingsStore((state) => state.searchQuery);
  const setSearchQuery = useSettingsStore((state) => state.setSearchQuery);

  const handleSearchClick = () => {
    if (searchQuery.trim()) {
      router.push('/search');
    }
  };

  const handleClearClick = () => {
    setSearchQuery('');
    // If on artist page, redirect to search
    if (pathname?.startsWith('/artist/')) {
      router.push('/search');
    }
  };

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchQuery(e.target.value);
  };

  const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter' && searchQuery.trim()) {
      router.push('/search');
    }
  };

  return (
    <div
      className={`relative mx-auto h-9 max-w-60 items-center ${className}`}
      data-node-id="3558:117566"
    >
      {/* Input background */}
      <div className="relative">
        <input
          type="text"
          placeholder={t('Search.title')}
          value={searchQuery}
          onChange={handleInputChange}
          onKeyDown={handleKeyDown}
          className="h-9 w-full rounded-[4px] bg-white/20 pl-3 pr-12 text-[18px] text-white transition placeholder:text-white/40 focus:outline-none focus:ring-2 focus:ring-ais-green"
          style={{ fontWeight: 400 }}
        />
        {searchQuery && (
          <button
            onClick={handleClearClick}
            className="absolute right-12 top-2 flex size-5 items-center justify-center transition-opacity hover:cursor-pointer hover:opacity-80"
            tabIndex={-1}
            type="button"
            title="Clear and close"
          >
            <IconRemoveText className="text-[#9E9E9E]" />
          </button>
        )}
      </div>

      {/* Vertical divider */}
      <div className="absolute right-10 top-2.5 h-4 w-px bg-white/20" />
      {/* Clear/Search button */}

      <button
        onClick={handleSearchClick}
        className="absolute right-3 top-2.5 flex size-4 items-center justify-center transition-opacity hover:cursor-pointer hover:opacity-80"
        tabIndex={-1}
        type="button"
      >
        <IconSearch />
      </button>
    </div>
  );
}
